import { render } from "./Boletim.vue?vue&type=template&id=10f7f040"
import script from "./Boletim.vue?vue&type=script&lang=ts"
export * from "./Boletim.vue?vue&type=script&lang=ts"
script.render = render

export default script